import React, { useState } from 'react';
import OptionsAndOther from '../../choose_an_option';

export default function SymptomManagement({ answers, onSubmit, onBack, gtm, showBack }) {
  return (
    <div className={`row activity-question`}>
      <div className='col-sm-2'></div>
      <div className='col-sm-8'>
        <OptionsAndOther
          answers={{ xcopriSymptomManagement: answers.xcopriSymptomManagement }}
          onSubmit={(newAnswers) =>
            onSubmit({ ...answers, xcopriSymptomManagement: newAnswers.xcopriSymptomManagement })
          }
          onBack={onBack}
          title={`Please specify how long you (or the patient) have been using XCOPRI® (cenobamate tablets) CV.`}
          keyForAnswer={`xcopriSymptomManagement`}
          choices={['Less than 1 month', '1-3 months', '4-6 months', '7 months to a year', 'A year or more']}
          selectOne
          showOther={false}
          showBack={showBack}
        />
      </div>
      <div className='col-sm-2'></div>
    </div>
  );
}
